import { Box, Typography, Avatar } from "@mui/material";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";
import ProfileTabs from "../common/ProfileTabs";
import { ROUTE_VIDEO_START } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import SeeviHeader from "../common/SeeviHeader";
import YouTube from "react-youtube";

const Avatar1 = styled(Avatar)({
  width: "51px",
  height: "51px",
});

const StyledTextBox = styled(Box)({
  fontSize: "16px",
  backgroundColor: "#ffffff",
  borderRadius: "10px",
  fontFamily: "Poppins, sans-serif",
  fontWeight: "400",
  color: "#1F2235",
  lineHeight: "1.5",
  marginLeft: "10px",
});

const CraftingVideo = () => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" bgcolor="#eeeeee" width="100%">
      <SeeviHeader />

      <ProfileTabs />

      <Box display="flex" flexDirection="column" alignItems="left" fontSize="14px" fontWeight="500" color="#757575">
        <Box display="flex" alignItems="center" pl={1} pr={5}>
          <Avatar1 src="/images/avatar-one.png" alt="Avatar" />
          <StyledTextBox mt={2}>
            <Box p={1.5}>
              <Typography className="custom-typography-video">
                Welcome to the fun part of crafting your Video
              </Typography>
            </Box>
          </StyledTextBox>
        </Box>

        <Box display="flex" alignItems="center" pl={1} pr={5} mt={1}>
          <StyledTextBox p={1.5}>
            <Typography className="custom-typography-video">
              A video leaves lasting impact. Create three 20 seconds videos that highlight your strengths, skills and
              interests.
            </Typography>
          </StyledTextBox>
        </Box>

        <Box display="flex" alignItems="center" pl={1} pr={5} mt={1}>
          <StyledTextBox p={1.5}>
            <Typography className="custom-typography-video">
              The video in 3 parts will highlight
              <br />
              <b style={{ fontWeight: 600 }}>1. About You </b>
              <br />
              <b style={{ fontWeight: 600 }}>2. Your Specialization & Projects </b>
              <br />
              <b style={{ fontWeight: 600 }}>3. Your@work</b>
            </Typography>
          </StyledTextBox>
        </Box>

        <Box display="flex" alignItems="center" pl={1} pr={5} mt={1} mb={2}>
          <StyledTextBox px={2}>
            <Typography className="custom-typography-video">Check out Milind&apos;s 3 videos.</Typography>
          </StyledTextBox>
        </Box>
        <Box sx={{ px: 2 }}>
          <Box>
            <YouTube
              videoId="9NAh4UBcn0Q"
              opts={{
                width: "100%",
                height: "200px",
                playerVars: {
                  autoplay: 0,
                  controls: 1,
                  rel: 0,
                  mute: 0,
                },
              }}
            />
            <p className="image-carousel-text">About You</p>
            <p className="image-carousel-description">Your interests outside of work</p>
          </Box>
          <Box mt={2}>
            <YouTube
              videoId="1GlwJJk92ZE"
              opts={{
                width: "100%",
                height: " 200px",
                playerVars: {
                  autoplay: 0,
                  controls: 1,
                  rel: 0,
                  mute: 0,
                },
              }}
            />
            <p className="image-carousel-text">Your Specialization & Projects</p>
            <p className="image-carousel-description">An academic achievement that you are proud of</p>
          </Box>
          <Box mt={2}>
            <YouTube
              videoId="S9lvkRkI5HI"
              opts={{
                width: "100%",
                height: "200px",
                playerVars: {
                  autoplay: 0,
                  controls: 1,
                  rel: 0,
                  mute: 0,
                },
              }}
            />
            <p className="image-carousel-text">You@work</p>
            <p className="image-carousel-description">A work environment that you thrive in</p>
          </Box>
        </Box>

        <Box display="flex" alignItems="center" pl={2} pr={2} mt={2} mb={4}>
          <Button
            sx={{
              backgroundColor: "white",
              borderRadius: "99px",
              fontSize: "16px",
              textTransform: "capitalize",
              width: "100%",
              fontWeight: 600,
              color: "#756DE9",
              border: "1.5px dashed #756DE9",
              "&:hover ": {
                backgroundColor: "#f5f5f5",
              },
            }}
            variant="contained"
            size="small"
            style={{ padding: "15px 40px" }}
            className="w-100 mt-2 btn-pad"
            onClick={() => navigate(ROUTE_VIDEO_START)}
          >
            Guide Me
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CraftingVideo;
